// eslint-disable-next-line import/prefer-default-export
export const getCampaignState = (state) => state.campaign;
